import {
  AppBar,
  Box,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Toolbar,
  Typography,
  withStyles,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import SendIcon from '@material-ui/icons/SendRounded';
import AttachFile from '@material-ui/icons/AttachFileRounded';
import { makeStyles } from '@material-ui/styles';
import { Link, useHistory } from 'react-router-dom';
import routes from '../../../../../Utils/routes.json';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import EditOutlined from '@material-ui/icons/EditOutlined';
import React, { useEffect, useState } from 'react';
import KenCard from '../../../../../global_components/KenCard';
import KenGrid from '../../../../../global_components/KenGrid';
import KenDialogBox from '../../../../../global_components/KenDialogBox';
import KenSelectWrap from '../../../../../global_components/KenSelect';
import { RiFilterLine } from 'react-icons/ri';
import Kentable from '../../../../../global_components/KenTable/kentable';
import { Message } from '@material-ui/icons';
import ChatLayout from '../../../components/ChatLayout';
import ChatInput from '../../../components/ChatInput';
import moment from 'moment';
import BreadCrumb from '../../../../../Components/BreadCrumb';
import {
  getExamModuleListData,
  getGradingAck,
  getGradingCourseDetails,
  getGradingPublish,
} from '../../../../../Utils/apiServices';
import '../../../../../style/index.css';
import KenDateTimePicker from '../../../../../global_components/KenDateTimePicker';
import KenLoader from '../../../../../Components/KenLoader';
import TablePaginationActions from '../../../../../global_components/KenGrid/TablePaginationActions';
import SamplePdf from '../../../../../Assets/samplePdf.pdf';
import GetAppIcon from '@material-ui/icons/GetApp';
import { useTranslation } from 'react-i18next';

const StyledTableCell = withStyles((theme) => ({
  /*   head: {
    backgroundColor: theme.palette.common.white,
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '10px',
    lineHeight: '150%',
    textTransform: 'uppercase',
    color: '#505F79',
    padding: 20,
  },
  body: {
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '100%',
    color: '#505F79',
  }, */
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  // root: {
  //   '&:nth-of-type(odd)': {
  //     backgroundColor: theme.palette.action.hover,
  //   },
  // },
}))(TableRow);

const arrayBreadCrumb = [
  // { head: 'ADMIN PORTAL', url: routes.adminManagement },
  {
    head: 'EXAM',
    url: routes.exam,
  },
  {
    head: 'GRADING',
  },
];

const chatData = [
  {
    sender: true,
    message: `Hey, Could you please let me know which chapters I have to cover
  in UX/UI paper?`,
    profilePic: 'https://ptetutorials.com/images/user-profile.png',
    time: '3 days ago',
  },
  {
    sender: false,
    message: `Hi Nandhini, you should include first 8 chapters in mid semester
    exam.`,
    profilePic: '',
    time: '3 days ago',
  },
  {
    sender: true,
    message: `Okay, Thank you gentleman!`,
    profilePic: 'https://ptetutorials.com/images/user-profile.png',
    time: '3 days ago',
  },
];

const ActionCellSendMessage = (row) => {
  const classes = useStyles();

  // Message Modal
  const [messageDialog, setMessageDialog] = useState(false);

  function handleMessageDialog() {
    setMessageDialog((prevState) => !prevState);
  }
  const { id } = row.row.values;

  const handleClick = () => {
    handleMessageDialog();
  };

  const [chats, setChats] = useState(chatData);
  const [typedMessage, setTypedMessage] = useState(
    'Anytime, You are always welcome!'
  );

  const messageChangeHandler = (e) => {
    setTypedMessage(e.target.value);
  };

  const sendMessageHandler = () => {
    if (!typedMessage) {
      return;
    }

    setChats((prev) => {
      return [
        ...prev,
        {
          sender: false,
          message: typedMessage,
          profilePic: '',
          time: moment(new Date()).fromNow(),
        },
      ];
    });

    setTypedMessage('');
  };
  return (
    <>
      <Message
        style={{
          color: '#092682',
          cursor: 'pointer',
        }}
        className="m-0"
        onClick={handleClick}
      />
      {/* Message Modal */}
      <KenDialogBox
        title={
          <Typography
            variant="p"
            className={classes.modalHeader}
            style={{ display: 'flex', alignItems: 'center ' }}
          >
            <p>
              <img
                style={{ borderRadius: '50%', marginRight: '10px' }}
                width="40"
                height="40"
                src={'http://dummyimage.com/174x172.png/5fa2dd/ffffff'}
                alt="user"
              />
              {'Jane Cooper'}
            </p>

            <p>A - 12345</p>
            <p>Campus 1</p>
            <p>Course 1</p>
          </Typography>
        }
        open={messageDialog}
        handleClose={() => handleMessageDialog()}
        hidePositiveButton={true}
        hideNegativeButton={true}
        maxWidth="md"
        dividers
      >
        <div className="chat-box-part">
          <ChatLayout chats={chats} />

          <ChatInput
            typedMessage={typedMessage}
            messageChangeHandler={messageChangeHandler}
            sendMessageHandler={sendMessageHandler}
          />
        </div>
      </KenDialogBox>
    </>
  );
};
const ActionCellEdit = (row, isUpdating) => {
  const classes = useStyles();
  return (
    <Box>
      <div style={{ display: 'flex' }}>
        <Button
          variant="primary"
          component={Link}
          className={classes.editbtn}
          to={`${routes.grading}/details`}
        >
          View / Edit
        </Button>
        <Button
          variant="primary"
          component={Link}
          style={{
            color: '#505F79',
            background: 'rgba(196, 196, 196,0.2)',
            borderRadius: '20px',
            fontSize: '10px',
            margin: '5px 5px',
            height: '23px',

            '&:hover': {
              background: 'rgba(196, 196, 196,0.2)',
              color: '#505F79',
            },
          }}
          // to={`${routes.currentProgrammes}/${id}/details`}
        >
          SEND
        </Button>
      </div>
    </Box>
  );
};

const CellWithButton = (row) => {
  const classes = useStyles();
  const { status } = row.row.values;

  console.log('statusstatusstatusstatusstatus', { row });

  let classOfBtn;
  if (status === 'Submitted') {
    // classOfBtn = classes.normal;
  } else if (status === 'Under Approval') {
    // classOfBtn = classes.medium;
  } else if (status === 'Not submitted') {
    // classOfBtn = classes.error;
  } else {
    // classOfBtn = classes.medium;
  }

  return (
    <Box>
      <Button
        variant="primary"
        component={Link}
        className={classOfBtn}
        style={{ alignContent: 'center' }}
        // to={`${routes.currentProgrammes}/${id}/details`}
      >
        {status}
      </Button>
    </Box>
  );
};

const UserCell = (row, name) => {
  return (
    <p>
      <img
        style={{ borderRadius: '50%', marginRight: '10px' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />
      {name}
    </p>
  );
};

const data = [
  {
    id: 1,
    course: <Link>ARTIFICAL INTILLEGENCE</Link>,
    subject: 'A - 12345',
    date_of_exam: '24 Jan 2022, 10:30 AM',
    subject_faculty: 'Nandini Clament',
    status: 'Submitted for Grading',
    action: 'action 1',
  },
  {
    id: 2,
    course: <Link>UI/UX DESIGN</Link>,
    subject: 'A - 02345',
    date_of_exam: '24 Jan 2022, 10:30 AM',
    subject_faculty: 'Nandini Clament',
    status: 'Under Approval',
    action: 'action 1',
  },
  {
    id: 3,
    course: <Link>Cameron Williamson</Link>,
    subject: 'A - 03345',
    date_of_exam: '24 Jan 2022, 10:30 AM',
    subject_faculty: 'Nandini Clament',
    status: 'Not submitted',
    action: 'action 1',
  },
  {
    id: 4,
    course: <Link>Esther Howard</Link>,
    subject: 'A - 12345',
    date_of_exam: '24 Jan 2022, 10:30 AM',
    subject_faculty: 'Nandini Clament',
    status: 'Submitted for Grading',
    action: 'action 1',
  },
  {
    id: 5,
    course: <Link>Wade Warren</Link>,
    subject: 'A - 02345',
    date_of_exam: '24 Jan 2022, 10:30 AM',
    subject_faculty: 'Nandini Clament',
    status: 'Submitted for Grading',
    action: 'action 1',
  },
  {
    id: 6,
    course: <Link>Cameron Williamson</Link>,
    subject: 'A - 03345',
    date_of_exam: '24 Jan 2022, 10:30 AM',
    subject_faculty: 'Nandini Clament',
    status: 'Submitted for Grading',
    action: 'action 1',
  },
  {
    id: 7,
    course: <Link>Jane Cooper</Link>,
    subject: 'A - 12345',
    date_of_exam: '24 Jan 2022, 10:30 AM',
    subject_faculty: 'Nandini Clament',
    status: 'Submitted for Grading',
    action: 'action 1',
  },
  {
    id: 8,
    course: <Link>Wade Warren</Link>,
    subject: 'A - 02345',
    date_of_exam: '24 Jan 2022, 10:30 AM',
    subject_faculty: 'Course 1',
    status: 'Submitted for Grading',
    action: 'action 1',
  },
];

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  subHeaderTitle: {
    width: '100%',
  },
  modalHeader: {
    fontWeight: 'normal',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    '& p': {
      marginRight: '25px',
    },
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',

    textDecoration: 'none',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    background: 'orange',
    borderRadius: '25px',
    fontSize: '10px',
    margin: '5px  5px',
    color: 'white',
    height: '23px',

    '&:hover': {
      color: 'white',
      background: 'orange',
    },
    // color: '#FFFFFF',
    // background: '#EB5757',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '70%',
  },
  normal: {
    color: 'white',
    background: 'green',
    borderRadius: '20px',
    fontSize: '10px',
    height: '23px',
    margin: '5px 5px',
    '&:hover': {
      background: 'green',

      color: 'white',
    },
    // color: '#FFFFFF',
    // background: '#27AE60',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '70%',
  },
  editbtn: {
    color: 'white !important',

    background: '#55b0cd',

    borderRadius: '20px',
    fontSize: '10px',
    height: '23px',

    margin: '5px 5px',
    '&:hover': {
      background: '#55b0cd',

      color: 'white !important',
    },
    // color: '#FFFFFF',
    // background: '##272727',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '100px',
  },
  Blue: {
    color: '#FFFFFF',
    background: '#272727',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '70%',
  },
  medium: {
    color: '#f17100',
    background: '#55b0cd',
    borderRadius: '20px',
    fontSize: '10px',
    margin: '5px 5px',
    height: '23px',

    '&:hover': {
      background: '#55b0cd',
      color: '#f17100',
    },
    // color: '#FFFFFF',
    // background: '#F2994A',
    // width: '70%',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
  table: {
    minWidth: 700,
    padding: 10,
  },
  tbCourseTerm: {
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '100%',
    color: '#02195E',
  },
  status: {
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '100%',
    color: '#FFFFFF',
    borderRadius: '18px',
    padding: '8px 20px',
  },
  viewEditBtn: {
    // background: "#03248F",
    borderRadius: '18px',
    padding: '8px 20px',
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '100%',
    textAlign: 'center',
    color: '#FFFFFF',
  },
  publishBtn: {
    background: '#979797',
    borderRadius: '18px',
    padding: '8px 20px',
    fontFamily: "'Open Sans'",
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '100%',
    textAlign: 'center',
    color: '#FFFFFF',
  },
  normal: {
    // color: '#505F79',
    color: 'white',

    background: 'green',
    // background: '#27AE60',

    // background: 'white',

    borderRadius: '20px',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px 5px',
    height: '23px',
    width: '115px',

    '&:hover': {
      background: 'green',

      color: 'white',
      // border: '1px solid white',
    },
  },
  medium: {
    color: '#f17100',
    background: '#55b0cd',
    textDecoration: 'none',

    borderRadius: '40px',
    fontSize: '10px',
    margin: '5px 5px',
    width: '115px',
    height: '23px',

    '&:hover': {
      background: '#55b0cd',
      color: '#f17100',
    },
  },
  error: {
    // color: '#F14B2D',

    background: 'orange',
    // background: 'white',
    // background: '#EB5757',

    borderRadius: '25px',
    // border: '1px solid white',
    fontSize: '10px',
    // fontWeight: 'bold',
    margin: '5px  5px',
    color: 'white',
    height: '23px',
    width: '115px',

    '&:hover': {
      color: 'white',
      background: 'orange',

      // color: 'white',
      // borderBottom: '#F14B2D',
    },
  },
  view: {
    color: 'white !important',

    background: '#55b0cd',
    width: '100px',
    borderRadius: '10px',
    fontSize: '12px',

    margin: '5px 5px',
    '&:hover': {
      background: '#55b0cd',

      color: 'white !important',
    },
  },
  publishView: {
    width: '100px',
    color: 'white',
    background: 'orange',
    borderRadius: '10px',
    fontSize: '12px',
    margin: '5px 5px',
    '&:hover': {
      background: 'orange',

      color: 'white',
    },
  },
  ACKButton: {
    // color: '#505F79',
    // background: 'rgba(196, 196, 196,0.2)',
    width: '100px',
    background: 'green',
    color: 'white',
    borderRadius: '10px',
    fontSize: '12px',
    margin: '5px 5px',
    '&:hover': {
      background: 'green',
      color: 'white',
    },
  },
}));

const selectOptionsBatch = [
  {
    label: 'Select Batch',
    value: '',
  },
  {
    label: 'February',
    value: 'February',
  },
  {
    label: 'April',
    value: 'April',
  },
  {
    label: 'October',
    value: 'October',
  },
  {
    label: 'December',
    value: 'December',
  },
];

const UserCellBulkMessage = (row, name) => {
  return (
    <p>
      <img
        style={{ borderRadius: '50%' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />
      {name}
    </p>
  );
};

const sendBulkDataGrid = [
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Raleigh Avieson'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Fleur Fowler'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Nealy Leitch'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Carolyne Angrock'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Abeu Aiers'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Penny Scrivinor'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Grier Laverick'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Dur Leile'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Claudine Owenson'
    ),
  },
  {
    name: UserCellBulkMessage(
      'http://dummyimage.com/174x172.png/5fa2dd/ffffff',
      'Stefa True'
    ),
  },
];

const Grading = () => {
  const history = useHistory();
  const { t } = useTranslation();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  // For FIlter Status
  const [filterData, setFilterData] = useState();

  const [examMonthData, setExamMonthData] = useState([]);
  const [selectCourseData, setselectCourseData] = useState([]);
  const [selectTermData, setselectTermData] = useState([]);
  const [selectCampusData, setselectCampusData] = useState([]);
  const [totalData, setTotalData] = useState(25);

  const [selectFacultyData, setselectFacultyData] = useState([]);

  const [loading, setLoading] = useState(false);

  const [selectValueCampus, setSelectValueCampus] = useState('');
  const handleSelectChangeCampus = (e) => {
    setSelectValueCampus(e.target.value);
  };
  const [selectValueProgram, setSelectValueProgram] = useState('');
  const handleSelectChangeProgram = (e) => {
    setSelectValueProgram(e.target.value);
  };

  const [selectValueSubject, setSelectValueSubject] = useState('');
  const handleSelectChangeSubject = (e) => {
    setSelectValueSubject(e.target.value);
  };

  const [selectValueTerm, setSelectValueTerm] = useState('');
  const handleSelectChangeTerm = (e) => {
    setSelectValueTerm(e.target.value);
    setSelectValueProgram('');
  };

  const [selectValueBatch, setSelectValueBatch] = useState('');
  const handleSelectChangeBatch = (e) => {
    setSelectValueBatch(e.target.value);
  };
  const [selectValueBatch1, setSelectValueBatch1] = useState([]);

  const [selectValueBatch12, setSelectValueBatch12] = useState('');
  const handleSelectChangeBatch12 = (e) => {
    setSelectValueBatch12(e.target.value);
  };

  const [selectValueExamCycle1, setSelectValueExamCycle1] = useState([]);

  const [selectValueExamCycle, setSelectValueExamCycle] = useState('');
  const handleSelectChangeExamCycle = (e) => {
    setSelectValueExamCycle(e.target.value);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [examDate, setexamDate] = useState('');

  const manageexamDate = (e, row) => {
    setexamDate(e.target.value);
  };

  const [filterDialog, setFilterDialog] = useState(false);

  function handleFilterDialog() {
    setFilterDialog((prevState) => !prevState);
  }

  const [sendBulkMessageDialog, setSendBulkMessageDialog] = useState(false);

  function handleSendBulkMessageDialog() {
    setSendBulkMessageDialog((prevState) => !prevState);
  }

  const [selectAllData, setSelectAllData] = useState(false);

  const handleSelectRow = (evt, row, index) => {
    // TODO code here to perform actions on selecting row in table
  };

  const handleSelectAllRows = (state) => {
    // TODO code here to perform actions on selecting all rows in table
    setSelectAllData(state);
  };

  // Editing
  const [dataOfTable, setDataOfTable] = useState(data);
  const [isEditing, setIsEditing] = useState(false);
  const [course, setCourse] = useState([]);

  useEffect(() => {
    getExamModuleListData().then((res) => {
      setFilterData(res);
    });
  }, []);

  useEffect(() => {
    let TermListData = filterData?.TermList.map((item) => {
      return {
        label: item.TermName,
        value: item.TermName,
      };
    });
    setselectTermData(TermListData);

    // For Course
    let CourseListData = filterData?.CourseList.filter((item) => {
      return (
        selectValueTerm == item.TermName && item.TermName && item.CourseName
      );
    }).map((item) => {
      return {
        label: item.CourseName,
        value: item.CourseName,
      };
    });

    setselectCourseData(CourseListData);

    // For Faculty
    let FacultyListData = filterData?.courseFacultyList
      .filter((item) => {
        console.log('item---Fac', item);
        return selectValueProgram === item.CourseName;
      })
      .map((itemss) => {
        let Fcaulty = itemss?.FacultyName?.map((item) => {
          return {
            label: item,
            value: item,
          };
        });

        return Fcaulty;
        // setselectFacultyData1(Fcaulty);
      });
    setselectFacultyData(FacultyListData);
    //For Campus
    let CampusListData = filterData?.campus.map((item) => {
      return {
        label: item,
        value: item,
      };
    });
    setselectCampusData(CampusListData);
    let BatchListData = filterData?.batchList
      .filter((item) => {
        return item != null;
      })
      .map((item) => {
        return {
          label: item,
          value: item,
        };
      });
    setSelectValueBatch1(BatchListData);

    let ExamCycleListData = filterData?.ExamMonthList.filter((item) => {
      return item != null;
    }).map((item) => {
      return {
        label: item,
        value: item,
      };
    });
    setSelectValueExamCycle1(ExamCycleListData);
  }, [filterData, selectValueTerm, selectValueProgram]);
  //Pagination

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const onAckClick = (status, id) => {
    getGradingAck(status, id)
      .then((res) => {
        console.log('resresresreresrrACk', res);
        // toast.success('Mail has send successfully with hall ticket', {
        //   position: 'top-right',
        //   autoClose: 5000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        // });
      })
      .catch((err) => {
        console.log('errorr', err);
      });
  };

  const onPublishClick = (status, id) => {
    getGradingPublish(status, id)
      .then((res) => {
        console.log('resresresreresrrACk', res);
      })
      .catch((err) => {
        console.log('errorr', err);
      });
  };

  const getGradingData = () => {
    setLoading(true);
    let filterData = {
      term: selectValueTerm,
      course: selectValueProgram,
      campus: selectValueCampus,
      subjectFaculty: selectValueSubject,
      status: selectValueBatch,
      examCycle: selectValueExamCycle,
      batch: selectValueBatch12,
      pageNo: page,
      count: rowsPerPage,

      // deadline: deadlineDate,
      // dateOfExam: examDate,
      // allocatedTo: selectValueAlloctedFaculty,
      // batch: selectValueBatch,
      // examCycle: selectValueExamCycle,
    };
    getGradingCourseDetails(filterData)
      .then((res) => {
        setLoading(false);
        console.log('getGradingCourseDetails', res);

        const EvaluationDetailsInfo =
          res?.evalutionList === null ? [] : res?.evalutionList;
        if (res !== null) {
          setCourse(EvaluationDetailsInfo);
        }

        setTotalData(res.noOfRecords);
      })
      .catch((err) => {
        setLoading(false);
        console.log(' Grading Course Details error', err);
      });
    setFilterDialog(false);
  };
  useEffect(() => {
    getGradingData();
  }, [page, rowsPerPage]);

  return (
    <Box>
      {loading && <KenLoader />}
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar
          style={{
            justifyContent: 'space-between',
          }}
        >
          <Typography variant="h6" className={classes.title}>
            Grading
          </Typography>
          <Grid item xs={6} style={{ display: 'flex', justifyContent: 'end' }}>
            {/* <Button
              startIcon={<GetAppIcon />}
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
            >
              <a
                href={SamplePdf}
                style={{ textDecoration: 'none', color: 'white' }}
                download
              >
                {t('labels:Report')}
              </a>
            </Button> */}
            <Button
              startIcon={<RiFilterLine />}
              variant="contained"
              color="primary"
              style={{ marginRight: '15px' }}
              className={classes.addButton}
              onClick={handleFilterDialog}
            >
              Filter
            </Button>
            <Button
              // startIcon={<Message />}
              variant="contained"
              color="primary"
              component={Link}
              className={classes.addButton}
              // onClick={handleSendBulkMessageDialog}
              style={{ marginRight: '15px' }}
              to={routes.gradingSetting}
            >
              Grading Setting
            </Button>
            {/* <Button
              variant="contained"
              color="primary"
              // style={{
              //   marginRight: '15px',
              //   background: '#979797',
              //   color: 'white',
              //   fontWeight: 'bold',
              //   textDecoration: 'none',
              //   textTransform: 'none',
              // }}
              className={classes.addButton}
              to={'#'}
            >
              Save
            </Button> */}
          </Grid>
        </Toolbar>
      </AppBar>
      {/* 
      <Box className={`cardlsitbox`}>
        <KenCard elevation={0}>
          <KenGrid
            columns={columns}
            data={dataOfTable}
            pagination={{ disabled: true }}
            toolbarDisabled={true}
            initialState={{
              hiddenColumns: ['id'],
            }}
            gridProps={{
              getCellProps: (row) => {
                if (
                  row.column.Header === 'Send Message' ||
                  row.column.Header === 'Edit'
                ) {
                  return {
                    style: {
                      textAlign: 'center',
                    },
                  };
                }
                return {
                  style: {
                    textAlign: 'left',
                  },
                };
              },
              getHeaderProps: (column) => {
                if (
                  column.Header === 'Send Message' ||
                  column.Header === 'Edit'
                ) {
                  return {
                    style: {
                      textAlign: 'center',
                    },
                  };
                }
                return {
                  style: {
                    textAlign: 'left',
                  },
                };
              },
            }}
          />
        </KenCard>
      </Box> */}

      {/* Filter Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            GRADING FILTER
          </Typography>
        }
        open={filterDialog}
        handleClose={() => handleFilterDialog()}
        negativeButtonClick={() => handleFilterDialog()}
        positiveButtonClick={() => getGradingData()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Term"
              options={selectTermData}
              value={selectValueTerm}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeTerm}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Course"
              options={selectCourseData}
              value={selectValueProgram}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeProgram}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Campus"
              options={selectCampusData}
              value={selectValueCampus}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeCampus}
              required
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Subject Faculty"
              options={selectFacultyData?.[0]}
              value={selectValueSubject}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeSubject}
              required
            />
          </Grid>

          {/* <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Status"
              options={selectOptionsBatch}
              value={selectValueBatch}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeBatch}
              required
            />
          </Grid> */}

          <Grid item xs={12} sm={6}>
            <KenDateTimePicker
              label="Date Of Exam"
              inputBaseRootClass={classes.kenDateTimePickerColor}
              placeholder="Date Of Exam"
              value={examDate}
              type="date"
              required={true}
              defaultValue={examDate}
              onChange={manageexamDate}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Batch"
              options={selectValueBatch1}
              value={selectValueBatch12}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeBatch12}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Exam Cycle"
              options={selectValueExamCycle1}
              value={selectValueExamCycle}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChangeExamCycle}
              required
            />
          </Grid>
        </Grid>
      </KenDialogBox>

      {/* Message Modal */}
      <KenDialogBox
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            Send Bulk Message
          </Typography>
        }
        open={sendBulkMessageDialog}
        handleClose={() => handleSendBulkMessageDialog()}
        negativeButtonClick={() => handleSendBulkMessageDialog()}
        positiveButtonClick={() => handleSendBulkMessageDialog()}
        positiveButtonText={<SendIcon />}
        negativeButtonText={<AttachFile />}
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <Box className="cardlsitbox">
              <KenCard elevation={0}>
                <Kentable
                  data={sendBulkDataGrid}
                  initialState={{
                    hiddenColumns: ['id'],
                  }}
                  allcheckboxData={(state) => handleSelectAllRows(state)}
                  onRowCheckBox={(event, row, index) =>
                    handleSelectRow(event, row, index)
                  }
                />
              </KenCard>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box className="cardlsitbox">
              <KenCard elevation={0}>
                <TextField
                  placeholder="Add Comments"
                  multiline
                  rows={10}
                  maxRows={'Infinity'}
                />
              </KenCard>
            </Box>
          </Grid>
        </Grid>
      </KenDialogBox>

      {/* new table design */}
      <TableContainer
        component={Paper}
        style={{ padding: '16px', marginTop: 16 }}
      >
        <Table>
          <TableHead className="tableHeader">
            <TableRow>
              <StyledTableCell className="tableHeaderTitle">
                COURSE
              </StyledTableCell>
              <StyledTableCell className="tableHeaderTitle">
                TERM
              </StyledTableCell>{' '}
              <StyledTableCell className="tableHeaderTitle">
                EXAM CYCLE
              </StyledTableCell>
              <StyledTableCell className="tableHeaderTitle">
                BATCH
              </StyledTableCell>
              <StyledTableCell className="tableHeaderTitle">
                DATE OF EXAM
              </StyledTableCell>
              <StyledTableCell className="tableHeaderTitle">
                SUBJECT FACULTY
              </StyledTableCell>
              <StyledTableCell className="tableHeaderTitle">
                STATUS
              </StyledTableCell>
              <StyledTableCell
                className="tableHeaderTitle tableHeaderRight"
                colSpan={3}
              >
                ACTIONS
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody className="tablebody1">
            {course?.map((ele, index) => {
              return (
                <StyledTableRow key={ele?.courseName}>
                  <StyledTableCell>{ele?.courseName}</StyledTableCell>
                  <StyledTableCell>{ele?.term}</StyledTableCell>{' '}
                  <StyledTableCell>{ele?.examCycle}</StyledTableCell>
                  <StyledTableCell>{ele?.batch}</StyledTableCell>
                  <StyledTableCell>
                    {ele?.deadline
                      ? moment(ele?.deadline).format('DD-MM-YYYY')
                      : ''}
                  </StyledTableCell>
                  <StyledTableCell>{ele?.subjectFaculty}</StyledTableCell>
                  <StyledTableCell>
                    <Button
                      style={{ fontSize: '10px' }}
                      // className={
                      //   ele?.status && ele?.status === 'Under process'
                      //     ? classes.medium
                      //     : ele?.status === 'Approved'
                      //     ? classes.normal
                      //     : classes.error
                      // }
                      /* style={{
                          backgroundColor:
                            ele?.status && ele?.status === 'Under process'
                              ? '#F2994A'
                              : ele?.status === 'Approved'
                              ? '#27AE60'
                              : '#EB5757',
                        }} */
                    >
                      {ele?.status}
                    </Button>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Button
                      className={classes.view}
                      // color="primary"
                      size="small"
                      variant="primary"
                    >
                      <Link
                        style={{ color: 'white' }}
                        to={{
                          pathname: `${routes.grading}/details/${ele?.courseOfferingId}`,
                          state: { gradingId: ele?.courseOfferingId },
                        }}
                      >
                        View / Edit
                      </Link>
                    </Button>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Button
                      className={classes.publishView}
                      size="small"
                      variant="primary"
                      onClick={() => onPublishClick(ele?.status, ele?.id)}
                    >
                      SEND
                    </Button>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Button
                      className={classes.ACKButton}
                      size="small"
                      variant="primary"
                      onClick={() => onAckClick(ele?.status, ele?.id)}
                    >
                      ACK
                    </Button>
                  </StyledTableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
          <TablePagination
            rowsPerPageOptions={[25, 50, 100]}
            colSpan={6}
            count={totalData ? totalData : course.length}
            rowsPerPage={rowsPerPage}
            page={page}
            SelectProps={{
              inputProps: { 'aria-label': 'rows per page' },
              native: true,
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
          />
        </Table>
      </TableContainer>
    </Box>
  );
};

export default Grading;
